import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api } from "../lib/api";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (localStorage.getItem("rk_admin_token")) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("rk_admin_token", res.data.token);
      localStorage.setItem("rk_admin_email", res.data.email);
      toast.success("Signed in.");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#222629] text-white flex items-center justify-center p-6 relative overflow-hidden">
      <div className="grain absolute inset-0" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(46,79,174,0.25),_transparent_60%)]" />
      <div className="relative w-full max-w-md bg-white/5 backdrop-blur-2xl border border-white/10 rounded-2xl p-10">
        <div className="bg-white rounded-xl p-3 inline-block mb-6 shadow-2xl">
          <img src="/rk-steel-logo.png" alt="R K STEEL" className="h-12 w-auto" />
        </div>
        <h1 className="mt-4 font-heading text-3xl font-semibold text-white tracking-tight">Admin Login</h1>
        <p className="text-sm text-neutral-400 mt-2">R K STEEL — Internal Console</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-neutral-400 font-heading">Email</label>
            <input
              data-testid="login-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border-b border-white/20 focus:border-[#B8823E] outline-none py-2 text-white"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-neutral-400 font-heading">Password</label>
            <input
              data-testid="login-password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-transparent border-b border-white/20 focus:border-[#B8823E] outline-none py-2 text-white"
            />
          </div>
          <button data-testid="login-submit-btn" type="submit" disabled={loading} className="btn-pill btn-primary w-full justify-center">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
